"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
require("../../common/style.scss");
var _urlUtils = require("../../common/utils/domain/urlUtils");
var _gemUrlFormatUtils = require("../../common/utils/domain/gemUrlFormatUtils");
var _logger = _interopRequireDefault(require("../../utils/logger"));
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /**
 * Created By Gems CLI
 * Issues and merge requests are welcomed：https://git.woa.com/hulk/gems
 *
 * API 参考：
 * http://gems.woa.com/?path=/docs/%E5%BC%80%E5%8F%91-%E4%B8%9A%E5%8A%A1%E7%B4%A0%E6%9D%90%E5%BA%93-%E7%BC%96%E5%86%99%E7%BB%84%E4%BB%B6--page
 */
const _require = require('@tencent/cms-design-component'),
  Banner = _require.Banner;
const formatBanner = (properties, options = {}) => {
  const _getFormatUrlMethods = (0, _gemUrlFormatUtils.getFormatUrlMethods)({
      domains: options === null || options === void 0 ? void 0 : options.domains
    }),
    formatUrlString = _getFormatUrlMethods.formatUrlString;
  const title = properties.title,
    article = properties.article,
    leftBtnText = properties.leftBtnText,
    leftBtnLink = properties.leftBtnLink,
    leftBtnVideoBg = properties.leftBtnVideoBg,
    leftVideo = properties.leftVideo,
    rightBtnText = properties.rightBtnText,
    rightBtnLink = properties.rightBtnLink,
    rightBtnVideoBg = properties.rightBtnVideoBg,
    rightVideo = properties.rightVideo,
    imageSrc = properties.imageSrc,
    backgroundUrlLogo = properties.backgroundUrlLogo,
    switchContent = properties.switchContent;
  const buttonList = [];
  function genBannerButtonItem(btnVideoBg, video, btnText, btnLink, index) {
    let item = {
      label: btnText,
      extendProps: {
        'report-event': 'click_banner_button',
        'report-event-goal': 'click_banner_button',
        'report-ext1': index,
        'report-ext2': btnText,
        'report-ext3': btnLink
      }
    };
    if (btnVideoBg && video) {
      item = _objectSpread(_objectSpread({}, item), {}, {
        filedVideoBg: btnVideoBg,
        filedVideoList: video,
        postMessageUrl: (0, _urlUtils.getVideoIframeUrl)(options)
      });
    } else {
      item = _objectSpread(_objectSpread({}, item), {}, {
        href: formatUrlString(btnLink || '')
      });
    }
    return item;
  }
  if (leftBtnText) {
    const item = genBannerButtonItem(leftBtnVideoBg, leftVideo, leftBtnText, leftBtnLink, 0);
    buttonList.push(item);
  }
  if (rightBtnText) {
    const item = genBannerButtonItem(rightBtnVideoBg, rightVideo, rightBtnText, rightBtnLink, 1);
    buttonList.push(item);
  }
  const insights = [{
    title,
    content: article
  }];

  /*
   * 格式化cms端传递过来的对应内容：
   * 1、判断目标字符串能否被转换为数组
   * 2、数组中的每一项为对象且有 text、href 和 chosed 属性
   * 如果都满足，返回对应的转换JSON后的内容，否则返回 []
   */
  function formatString(content) {
    // 因为cms配置的数据项中，当 chosed 属性为 false 时不输出，
    // 所以需要一个新数据来存储格式化后的数据-当没有chosed属性时
    const newContent = [];
    if (Object.prototype.toString.call(content) === '[object Array]') {
      for (let i = 0; i < content.length; i++) {
        const item = content[i];
        // eslint-disable-next-line no-prototype-builtins
        if (!(Object.prototype.hasOwnProperty.call(item, 'text') && Object.prototype.hasOwnProperty.call(item, 'href'))) {
          return [];
        }
        if (!Object.prototype.hasOwnProperty.call(item, 'chosed')) {
          newContent.push(_objectSpread(_objectSpread({}, item), {}, {
            chosed: false
          }));
        } else {
          newContent.push(item);
        }
      }
      return newContent;
    }
    return [];
  }

  // 兼容以前的 Banner组件 - 没有 switchContent 这个组件的数据；
  let switchList;
  try {
    switchList = formatString(switchContent);
  } catch (error) {
    _logger.default.error(error);
    switchList = [];
  }
  return {
    imageSrc,
    backgroundUrlLogo,
    insights,
    buttonList,
    switchList
  };
};
function _default({
  componentKey,
  // {number} 用于标识每一个组件实例的全局唯一且持久化的 key
  data,
  // {object} “数据”表单内容
  style,
  // {object} “样式”表单内容
  commonStyle,
  // {object} “组件自定义样式”表单内容
  global,
  // {object} 页面容器自定义的全局配置项
  meta,
  // {object} 页面元数据
  componentsMap,
  // {Map<number, HTMLElement>} 所有组件 DOM 节点的 Map，key 为组件的 key（number）
  getComponentByKey,
  // {(key: number) => HTMLElement | undefined} 通过组件 key 获取组件 DOM 节点的 API
  store,
  // {object} 组件状态
  on,
  // {(event: string, callback: Function) => void} 事件触发调用
  emit,
  // {(event: string) => void | Promise<void>} 监听事件
  domains: domainInfos
}) {
  const domains = (0, _gemUrlFormatUtils.useDomainGems)({
    domainInfos
  });
  if (Object.keys(data).length > 1) {
    const _formatBanner = formatBanner(data, {
        domains
      }),
      imageSrc = _formatBanner.imageSrc,
      backgroundUrlLogo = _formatBanner.backgroundUrlLogo,
      insights = _formatBanner.insights,
      buttonList = _formatBanner.buttonList,
      switchList = _formatBanner.switchList;
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Banner, {
      backgroundUrl: imageSrc,
      backgroundUrlLogo: backgroundUrlLogo,
      insights: insights,
      buttonList: buttonList,
      tabShow: switchList.length > 0,
      tabList: switchList
    }));
  } else {
    return /*#__PURE__*/React.createElement("div", null);
  }
}